import { FC } from 'react';
import cs from 'classnames';
import { Radio } from '@forgeglobal/design-framework';
import { FieldRenderProps } from 'react-final-form';
import { useStyles } from './style';

const RadioWrapper: FC<FieldRenderProps<any>> = ({
  input: { checked, value, name, onChange, ...restInput },
  meta,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Radio
      {...rest}
      name={name}
      inputProps={restInput}
      onChange={onChange}
      checked={checked}
      value={value}
      className={cs(classes.radio, {
        [classes.error]: meta.error && meta.touched,
      })}
    />
  );
};

export default RadioWrapper;
